const PRODUCT = {
  SEARCH: 'SEARCH',
  API: 'API',
  VERIFY_API: 'VERIFY_API',
};

const PRODUCT_TYPE = {
  API_TRIAL: 'API_TRIAL',
  API_PURCHASE: 'API_PURCHASE',

  SEARCH_PURCHASE: 'SEARCH_PURCHASE',
  SEARCH_TRIAL: 'SEARCH_TRIAL',

  VERIFY_API_PURCHASE: 'VERIFY_API_PURCHASE',
  VERIFY_API_TRIAL: 'VERIFY_API_TRIAL',
};

export default {
  PRODUCT_TYPE,
  PRODUCT,
};
